/* eslint-disable prefer-const */
import React from 'react';
import { useT } from 'talkr';
import styles from './textSlider.module.scss';

function TextSlider() {
  const { T } = useT();
  return (
    <div className={styles.containerAboutLoader}>
      <div className={styles.containerAboutLoaderItem}>{T('adapting_a_plan')}</div>
    </div>
  );
}

export default TextSlider;
